import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { ApButtonTab } from '@alixpartners/ui-components';
import {
	ContainerWrapper,
	ContentDiv,
	SectionWrapper,
} from './Fragmentation.styles';
import ShareOfTotalSpendSection from '.././ShareOfTotalSpendSection'; // Assuming this is the correct path
import { DualSourcedSkuProfileChartContainer } from 'Investigate/SkuStackedBarChart/DualSourcedSkuProfileChartContainer';

const FRAGMENTATION_CONFIG = [
	{
		id: 1,
		name: 'Vendor Fragmentation',
		label: 'Vendor Fragmentation',
		isActive: true,
	},
	{
		id: 2,
		name: 'SKU Fragmentation',
		label: 'SKU Fragmentation',
		isActive: false,
	},
	{
		id: 3,
		name: 'Dual Sourced SKU Profile',
		label: 'Dual Sourced SKU Profile',
		isActive: false,
	},
];

export const Fragmentation = ({
	spendType,
	queryParams,
	currencySymbol,
	showExplorePage,
	onDownloadError,
	onDownloadSuccess,
	onDownloadStart,
}) => {
	const [subNav, setSubNav] = useState(FRAGMENTATION_CONFIG);
	const [activeComponent, setActiveComponent] = useState(null);
	const location = useLocation();
	useEffect(
		() => {
			if (location.state?.isSegment) {
				subNavHandler(2);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[location.state?.isSegment]
	);

	useEffect(
		() => {
			if (location.state?.isMaster) {
				subNavHandler(1);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[location.state?.isMaster]
	);

	const subNavHandler = value => {
		setSubNav(prevState =>
			prevState.map(el => ({ ...el, isActive: el.id === value }))
		);

		const isSku = value === 2;

		setActiveComponent(
			value === 3 ? (
				<DualSourcedSkuProfileChartContainer
					queryParams={queryParams}
					spendType={spendType}
				/>
			) : (
				<ShareOfTotalSpendSection
					key={`fragmentation-${value}`}
					cardTitle={isSku ? 'SKU Fragmentation' : 'Vendor Fragmentation'}
					currencySymbol={currencySymbol}
					queryParams={queryParams}
					spendType={spendType}
					onDownloadError={onDownloadError}
					onDownloadSuccess={onDownloadSuccess}
					onDownloadStart={onDownloadStart}
					showExplorePage={showExplorePage}
					isSku={isSku}
				/>
			)
		);
	};

	useEffect(
		() => {
			const initialActiveTab = subNav.find(tab => tab.isActive)?.id;
			if (initialActiveTab) {
				subNavHandler(initialActiveTab);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[spendType, queryParams]
	);

	return (
		<ContainerWrapper>
			<SectionWrapper>
				{subNav.map(({ id, name, label, isActive }) => (
					<ApButtonTab
						key={id}
						name={name}
						isSelected={isActive}
						onClick={() => {
							subNavHandler(id);
						}}
						small
					>
						{label}
					</ApButtonTab>
				))}
			</SectionWrapper>
			<ContentDiv>{activeComponent}</ContentDiv>
		</ContainerWrapper>
	);
};

export default Fragmentation;
